<script setup>
import { usePlatform } from '/app/composables/platform';
import { useAuth } from '/app/composables/auth';
import { computed } from 'vue';
import NIcon from '/app/components/NIcon.vue';

const { auth } = useAuth();
const { platform, isBignerve, isUserPlatform } = usePlatform();
const currentUser = computed(() => auth.current);
</script>

<template>
    <div class="page__sidebar-inside">
        <ul>
            <li>
                <RouterLink :to="{ name: 'account.my-account.email-preferences' }">Email &amp; Alert Preferences</RouterLink>
            </li>
            <li>
                <RouterLink :to="{ name: 'account.my-account.security' }">Password &amp; Security</RouterLink>
            </li>
            <li>
                <RouterLink :to="{ name: 'account.my-account.social' }">Social Integrations</RouterLink>
            </li>
            <li>
                <RouterLink :to="{ name: 'account.my-account.payment-wallets' }">Payment Wallets
                    <NIcon as="money-bill-alt-regular" class="ml-3" />
                </RouterLink>
            </li>
        </ul>
        <div class="border-t my-3  border-dashed"></div>
        <ul>
            <li>
                <RouterLink :to="{ name: 'account.my-account.masthead' }">Your Masthead</RouterLink>
            </li>
            <li>
                <RouterLink :to="{ name: 'account.my-account.profile' }">Your Bio & Profile</RouterLink>
            </li>
            <li>
                <RouterLink :to="{ name: 'account.my-account.organization' }">Your Organization</RouterLink>
            </li>
        </ul>
        <div class="border-t my-3  border-dashed"></div>
        <em class="mb-2">Shortcuts:</em>
        <ul class="!pl-4">
            <li v-if="currentUser.user.id">
                <RouterLink :to="{ name: 'dashboard.dashboard', params: { platformSlug: currentUser.user.screen_name } }">
                    My Dashboard
                </RouterLink>
            </li>
            <li v-if="currentUser.user.id">
                <RouterLink :to="{ name: 'discussion-forums.most-recent', params: { platformSlug: currentUser.user.screen_name } }">
                    My Forum
                </RouterLink>
            </li>
            <li non-functional>
                <a href="/nerve-boards">Nerve Boards</a><!-- to fix later -->
            </li>
            <li>
                <RouterLink :to="{ name: 'faqs' }">FAQs</RouterLink>
            </li>
        </ul>
    </div>
</template>
